import { Accordion } from '@monorepo/shared/componentsV2/Accordion';
import React from 'react';
import styled from 'styled-components';
import { HandleUploadPdf, PdfUploader } from './PdfUploader';

const GenerateFormTemplateInputsContainer = styled.div`
  margin-bottom: 1.5rem;
`;

const StyledAccordionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  margin: 0;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.5rem;
`;

const StyledAccordion = styled(Accordion)`
  margin-bottom: 0.5rem;

  /* removes an odd thin gray line MUI places there */
  &::before {
    background-color: transparent;
  }

  &.Mui-expanded {
    margin-top: 0;
    margin-bottom: 0.5rem;
  }

  .MuiAccordionSummary-root:not(:focus-visible) {
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

const StyledLabel = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
`;

export function GenerateFormTemplateInputs({
  className,
  customPrompt,
  handleUpload,
  isProcessing,
  setCustomPrompt,
  startedProcessingAt,
}: {
  className?: string;
  customPrompt?: string;
  handleUpload: HandleUploadPdf;
  isProcessing: boolean;
  setCustomPrompt: (customPrompt: string) => void;
  startedProcessingAt?: Date;
}) {
  return (
    <GenerateFormTemplateInputsContainer>
      <StyledAccordion
        variant="contained"
        summaryContent={<StyledLabel>Custom AI prompt</StyledLabel>}
        defaultExpanded
        detailsContent={
          <StyledAccordionContent className={className}>
            <PdfUploader
              handleUpload={handleUpload}
              customPrompt={customPrompt}
              setCustomPrompt={setCustomPrompt}
              isProcessing={isProcessing}
              startedProcessingAt={startedProcessingAt}
            />
          </StyledAccordionContent>
        }
      />
    </GenerateFormTemplateInputsContainer>
  );
}
